import { makeStyles } from '@material-ui/core';

const useIndividualOverviewStyles = makeStyles((theme) => {
  return ({
    wrapper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
  });
});

export default useIndividualOverviewStyles;
